export const SET_ADMIN_TREND_EDIT_REQUEST = 'SET_ADMIN_TREND_EDIT_REQUEST';
export const SET_ADMIN_TREND_EDIT_SUCCESS = 'SET_ADMIN_TREND_EDIT_SUCCESS';
export const SET_ADMIN_TREND_EDIT_FAILED = 'SET_ADMIN_TREND_EDIT_FAILED';
export const SET_ADMIN_TREND_SUCCESS = 'SET_ADMIN_TREND_SUCCESS';
export const SET_ADMIN_TREND_EDIT_INFLUENCE_SUCCESS = 'SET_ADMIN_TREND_EDIT_INFLUENCE_SUCCESS';
export const SET_ADMIN_TREND_EDIT_SCENARIO_SUCCESS = 'SET_ADMIN_TREND_EDIT_SCENARIO_SUCCESS';
export const CLEAN_EDIT_TREND = 'CLEAN_EDIT_TREND';
